import React from 'react';
import ReactDOM from 'react-dom';
import 'react-calendar-timeline/lib/Timeline.css'
import './index.css';
import App from './App';
import {Provider} from 'react-redux'
import store from './store';
import ReactGA from 'react-ga';
import firebase from 'firebase';
require("firebase/firestore");

// Initialize Firebase
const config = {
    apiKey: "AIzaSyDwWfMr8jrH_GrAq4RTJR_tlatFkgyY5Hc",
    authDomain: "sailing-routes.firebaseapp.com",
    databaseURL: "https://sailing-routes.firebaseio.com",
    projectId: "sailing-routes",
    storageBucket: "sailing-routes.appspot.com",
    messagingSenderId: "1056603227597"
};
firebase.initializeApp(config);
firebase.firestore().settings({timestampsInSnapshots: true});
ReactGA.initialize('UA-125827241-1'); //Unique Google Analytics tracking number

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>, document.getElementById('root'));
// registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js